import Swiper from 'swiper';
import {Autoplay, Pagination, Navigation, EffectFade, Scrollbar} from 'swiper/modules';
import 'swiper/css/bundle';

const main = () => {
    const swiper = new Swiper(".c-others-block-links__inner", {
        loop: true,
        speed: 1000,
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        breakpoints: {
            640: {
                spaceBetween: 20,
                slidesPerView: 2.7,
            }
        }
    });
}

export default main;
